import { toIpynb } from "~/notebook/core/ipynb";
import { type Notebook } from "~/notebook/model/model";

export function blankNotebookFile(displayName: string): File {
  const fileName = displayName.endsWith(".ipynb") ? displayName : `${displayName}.ipynb`;
  const baseName = fileName.replace(/\.ipynb$/i, "");
  const blank: Notebook = {
    resourceId: "",
    displayName: fileName,
    extension: "ipynb",
    revisionLabel: "v1",
    cells: [
      {
        id: `cell-${crypto.randomUUID()}`,
        kind: "markdown",
        source: `# ${baseName}\n\nDescribe what this notebook does. Link resources from the system using the @ menu in a cell.`,
        links: [],
      },
    ],
    createdAt: new Date().toISOString(),
  };
  const json = JSON.stringify(toIpynb(blank), null, 1);
  return new File([json], fileName, { type: "application/x-ipynb+json" });
}
